var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59 18.57C8.59 18.57 8.53 18.57 8.5 18.57C4.33 17.84 1.3 14.24 1.3 9.99999C1.3 5.75999 4.33 2.15999 8.5 1.42999C8.65 1.40999 8.79 1.44999 8.91 1.53999C9.02 1.63999 9.09 1.77999 9.09 1.91999V2.73999C9.09 3.23999 9.5 3.64999 10 3.64999C10.5 3.64999 10.91 3.23999 10.91 2.73999V1.92999C10.91 1.77999 10.98 1.63999 11.09 1.54999C11.2 1.45999 11.35 1.41999 11.5 1.43999C15.67 2.16999 18.7 5.76999 18.7 9.99999C18.7 14.23 15.67 17.84 11.5 18.56C11.36 18.59 11.21 18.55 11.09 18.45C10.97 18.35 10.91 18.21 10.91 18.07V17.25C10.91 16.75 10.5 16.34 10 16.34C9.5 16.34 9.09 16.75 9.09 17.25V18.07C9.09 18.22 9.02 18.36 8.91 18.45C8.82 18.53 8.7 18.57 8.59 18.57ZM10 15.34C11.05 15.34 11.91 16.2 11.91 17.25V17.45C15.3 16.59 17.7 13.54 17.7 9.99999C17.7 6.45999 15.3 3.40999 11.91 2.54999V2.74999C11.91 3.79999 11.05 4.65999 10 4.65999C8.95 4.65999 8.09 3.79999 8.09 2.74999V2.54999C4.7 3.40999 2.3 6.44999 2.3 9.99999C2.3 13.55 4.7 16.59 8.09 17.45V17.25C8.09 16.2 8.95 15.34 10 15.34Z",
    fill: "#00C2CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56 12.52C6.28 12.52 6.06 12.3 6.06 12.02V7.98C6.06 7.7 6.28 7.48 6.56 7.48C6.84 7.48 7.06 7.7 7.06 7.98V12.02C7.06 12.3 6.84 12.52 6.56 12.52Z",
    fill: "#00C2CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.44 12.52C13.16 12.52 12.94 12.3 12.94 12.02V7.98C12.94 7.7 13.16 7.48 13.44 7.48C13.72 7.48 13.94 7.7 13.94 7.98V12.02C13.94 12.3 13.72 12.52 13.44 12.52Z",
    fill: "#00C2CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4,
    height: 17.14,
    fill: "white",
    transform: "translate(1.3 1.42999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric);
export default __webpack_public_path__ + "static/media/generic.f963b73f36a783f952f42e9d9ec3312e.svg";
export { ForwardRef as ReactComponent };